import { unstable_generateUtilityClass as generateUtilityClass, unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';
export function getPickersToolbarTextUtilityClass(slot) {
  return generateUtilityClass('MuiPickersToolbarText', slot);
}
export var pickersToolbarTextClasses = generateUtilityClasses('MuiPickersToolbarText', ['root', 'selected']);